import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { Individual } from '../..//model/individual';
import { WizardService } from '../../wizard/wizard.service';

@Component({
  selector: 'app-signup-header',
  templateUrl: './signup-header.component.html',
  styleUrls: ['./signup-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignupHeaderComponent implements OnInit {

  public Individual: Individual;

  constructor(
    private wizard: WizardService
  ) { }

  public ngOnInit(): void {
    this.Individual = this.wizard.Individual;
  }

}
